var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9944 26.5555C13.4467 26.5555 6.99969 27.7455 6.99969 32.5055C6.99969 37.2673 13.4064 38.4993 20.9944 38.4993C28.5422 38.4993 34.9892 37.311 34.9892 32.5493C34.9892 27.7875 28.5842 26.5555 20.9944 26.5555Z",
    fill: "#99BAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.9944 22.0215C26.1359 22.0215 30.2554 17.9003 30.2554 12.7605C30.2554 7.62076 26.1359 3.49951 20.9944 3.49951C15.8547 3.49951 11.7335 7.62076 11.7335 12.7605C11.7335 17.9003 15.8547 22.0215 20.9944 22.0215Z",
    fill: "#A4A4A4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.68e43c5c0abf9e96c0575a57517813f1.svg";
export { ForwardRef as ReactComponent };